<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><a href="#/OEBPS/toc.htm#als"><em>Also by Leila Aboulela</em></a></p>
<p class="center1">Lyrics Alley<br/>Minaret<br/>Coloured Lights<br/>The Translator</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// als.vue?50df487c